import { render, staticRenderFns } from "./cmsEdit.vue?vue&type=template&id=19d13a50"
import script from "./cmsEdit.vue?vue&type=script&lang=js"
export * from "./cmsEdit.vue?vue&type=script&lang=js"
import style0 from "./cmsEdit.vue?vue&type=style&index=0&id=19d13a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports